import React, { useState } from 'react';
import {Button, Form, Input, Modal, Radio, ConfigProvider, notification} from 'antd';
import Axios from "../../../config/axiosConfig/axios";
import {Api} from "../../../config/apiList/api";
import {useNavigate} from "react-router-dom";
const EditUserDetails = ({ open, onCreate, onCancel , isLogin}) => {
    const [form] = Form.useForm();

    return (
        <ConfigProvider direction="rtl">
        <Modal
            style={{fontFamily: "iranSansBold"}}
            open={open}
            title="تغییر جزئیات کاربر"
            okText="تایید"
            cancelText="انصراف"
            onCancel={onCancel}
            closable={false}
            onOk={() => {
                form
                    .validateFields()
                    .then((values) => {
                        form.resetFields();
                        onCreate(values);
                    })
                    .catch((info) => {
                    });
            }}
        >


            <Form
                form={form}
                layout="vertical"
                name="form_in_modal"
                initialValues={{
                    ["days"]: 0,
                    modifier: 'public',
                }}
            >

                <Form.Item name="days" label="افزودن اعتبار(روز)"
                           rules={[
                               {
                                   required: false,
                                   message: 'لطفا برای تعداد روز مقداری وارد کنید!',
                               },
                           ]}
                >
                    <Input type="number" min={0}/>
                </Form.Item>

                <Form.Item name="isLogin" className="collection-create-form_last-form-item" label="وضعیت ورود"
                          isLogin={isLogin}
                           rules={[
                               {
                                   required: false,
                                   message: 'لطفا وضعیت ورود را مشخص کنید!',
                               },
                           ]}
                >
                    <Radio.Group defaultValue={isLogin}>

                        <Radio value={true} name={"True"}>وارد شده</Radio>
                        <Radio value={false} name={"False"}>وارد نشده</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

const Mod = (props) => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }
    const onCreate = async (values) => {

        let days = parseInt(values.days);
        let isLogin = values.isLogin;

        if(isLogin === undefined || isLogin === null){
            isLogin = props.isLogin;
        }

        if(days === undefined || days === null || days === ""){
            days = 0
        }

        const data = {
            userId: props.userId,
            days: days,
            isLogin: isLogin
        }


        await Axios.post("",`${Api}change-user-details`, data
        )
            .then(async (data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    await notification.open({
                        message: "موفقیت",
                        description: "درخواست با موفقیت انجام شد!",
                        style: {
                            background: "#43a047",
                            color: "white",
                            fontFamily: "IRANSansMobileFaNum",
                            borderRadius: "5px",
                        }
                    })

                }

                else{
                    RedNotification(data.message);
                }

            })
            .catch((error) => {
            });

        await Axios.get(`${Api}user-list-panel?page=${props.pageNumber}`
        )
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    props.changeUserList(data.data.data);
                }

            })
            .catch((error) => {
            });


        // // console.log('Received values of form: ', values);
        await setOpen(false);
    };
    return (
        <div>
            <Button
                type="primary"
                onClick={() => {
                    setOpen(true);
                }}
            >
                عملیات
            </Button>
            <EditUserDetails isLogin={props.isLogin}

                open={open}
                onCreate={onCreate}
                onCancel={() => {
                    setOpen(false);
                }}
            />
        </div>
    );
};
export default Mod;